export const SIDEBAR_ERRORS_SET_ERRORS = 'SIDEBAR_ERRORS_SET_ERRORS';
export const setErrors = (errorList, sectionId) => ({
  type: SIDEBAR_ERRORS_SET_ERRORS,
  errorList, // ['string']
  sectionId,
});

export const SIDEBAR_ERRORS_CLEAR_ERRORS = 'SIDEBAR_ERRORS_CLEAR_ERRORS';
export const clearErrors = (sectionId = 'all-sections') => ({
  type: SIDEBAR_ERRORS_CLEAR_ERRORS,
  sectionId,
});
